<!-- 获取车辆屏显及语音接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCodes": ["2KNTYVWC"]
        },
        responseCode: {
          "data": {
            "count":9270,
            "currCount":9270,
            "recordList":[
              {
                "freeTime":1,
                "normalPermitCount":0,
                "normalRemainCount":0,
                "parkCode":"2KNTYVWC",
                "totalPermitCount":300,
                "totalRemainCount":95
              }
            ]
          },
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台获取停车场剩余车位和车场免费时长",
          t_url: this.commonUrls.test + "getParkRemainCarportAndFreeTime",
          p_url: this.commonUrls.prod + "getParkRemainCarportAndFreeTime",
          precondition: "无",
          fitSystem: "VEMS传统停车场, 云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: [{
                info1: 'parkCodes',
                info2: '是',
                info3: 'JSONArray',
                info4: '停车场编号列表'
              }
            ]
          }],
          R_params: [{
              titleName: null,
              tabledata: [{
                tableHead: '参数名',
                tdName: 'info1'
              }, {
                tableHead: '是否必填',
                tdName: 'info2'
              }, {
                tableHead: '类型',
                tdName: 'info3'
              }, {
                tableHead: '说明',
                tdName: 'info4'
              }],
              td: [{
                info1: 'recordList',
                info2: '是',
                info3: 'JSONArray',
                info4: '记录列表'
              },{
                info1: 'count',
                info2: '是',
                info3: 'Integer',
                info4: '总计'
              },{
                info1: 'currCount',
                info2: '是',
                info3: 'Integer',
                info4: 'recordList总计'
              },
              ]
            },
            {
              titleName: "recordList",
              tabledata: [{
                tableHead: '参数名',
                tdName: 'info1'
              }, {
                tableHead: '是否必填',
                tdName: 'info2'
              }, {
                tableHead: '类型',
                tdName: 'info3'
              }, {
                tableHead: '说明',
                tdName: 'info4'
              }],
              td: [{
                info1: 'parkCode',
                info2: '是',
                info3: 'String',
                info4: '停车场编号'
              },{
                info1: 'mpgsRemainCount',
                info2: '否',
                info3: 'Integer',
                info4: 'mpgs 总空车位数'
              },{
                info1: 'totalRemainCount',
                info2: '是',
                info3: 'Integer',
                info4: '总空车位数'
              },{
                info1: 'totalPermitCount',
                info2: '是',
                info3: 'Integer',
                info4: '总车位数'
              },{
                info1: 'normalRemainCount',
                info2: '是',
                info3: 'Integer',
                info4: '总临时车位空车位数'
              },{
                info1: 'normalPermitCount',
                info2: '是',
                info3: 'Integer',
                info4: '总临时车位数'
              },{
                info1: 'freeTime',
                info2: '是',
                info3: 'Integer',
                info4: '免费停车时长，单位分钟'
              },
              ]
            },


          ],
          codeStatus: [{
            titleName: null,
            tabledata: [{
              tableHead: '状态码',
              tdName: 'info1'
            }, {
              tableHead: '说明',
              tdName: 'info2'
            }],
            td: [{
              info1: '000110',
              info2: '失败',
            }, {
              info1: '00110000',
              info2: '失败',
            }, {
              info1: '110000',
              info2: '失败',
            }]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/park/getParkRemainCarportAndFreeTime.vue